import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import './Home.css'
import Navbar from '../../components/Navbar/Navbar'
import Sidebar from '../../components/Sidebar/Sidebar'
import API from '../../utils/API'

function Home(props) {
  // Get window location to pass to sidebar
  const location = useLocation();
  const navigate = useNavigate();

  const { user, isSidebarOpen, setIsSidebarOpen } = props;

  useEffect(()=>{
    API.updateUserLastSeen()
    .catch((err)=>{
      console.error(`Error updating user's last seen date`);
      console.error(err);
    })
    let interval = setInterval(()=>{
      API.updateUserLastSeen()
      .then((res) => {
        // pass
      })
      .catch((err)=>{
        console.error(`Error updating user's last seen date`);
        console.error(err);
      })
    }, 1000*60)
    return () => clearInterval(interval);
  }, [])

  useEffect(() => {
    console.log('(Home.js) User:', user)
  }, [user])

  const sidebarProps = {
    isSidebarOpen, setIsSidebarOpen
  }

  return (
    <>
      <Navbar />
      <Sidebar {...sidebarProps} />
      <div className='wrapper'>
        <Outlet isSidebarOpen={isSidebarOpen} />
      </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(Home)
